/**
 * AI Settings - 简体中文本地化
 */

export default {
    aiSettings: {
        title: 'AI 设置',
        description: '配置 AI 如何响应您的请求',
        loading: '加载设置中...',
        saving: '保存中...',
        saveSuccess: '设置保存成功',
        saveError: '保存设置失败，请重试',
        selectLanguage: '选择 AI 输出语言',

        outputLanguage: {
            title: 'AI 输出语言',
            description: '选择 AI 在回答问题和生成内容时使用的语言',
        },

        error: {
            title: '错误',
        },

        info: {
            title: '工作原理：',
            point1: 'AI 将使用您选择的语言回复所有对话',
            point2: '设置会在您的所有设备间同步',
            point3: '更改会立即对新对话生效',
        },
    },
};
